import { translate } from '@repo/phrase';
import { Heading, Paragraph } from '@repo/ui/typography';

import { formatPrice } from '@/utils/translation.utils';

import styles from './styles.module.scss';

interface Props {
    numberOfServices: number;
    totalPrice: number;
    currency: string | undefined;
}

export const ServicesTitle = ({ numberOfServices, totalPrice, currency }: Props) => {
    return (
        <div data-testid="services-title" className={styles.services_title}>
            <div className={styles.services_title_left}>
                <Heading headingSize="xs">{translate('services_title')}</Heading>
                <Paragraph>
                    {translate('services_title_service', {
                        number: numberOfServices.toFixed(0),
                    })}
                </Paragraph>
            </div>
            <div className={styles.services_title_right}>
                <Paragraph>{translate('services_title_total')}</Paragraph>
                <Paragraph className={styles.price_total ?? ''}>{formatPrice(totalPrice, currency)}</Paragraph>
            </div>
        </div>
    );
};
